export default "__VITE_ASSET__DCVohxK3__"